import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message, Modal } from "antd";

import { AuthAction } from "../../store/actions";

import CodeInput from "../../components/inputbox/codeinput";
import Spacer from "../../components/spacer/spacer";
import GreyButton from "../../components/button/greybutton";
import { TextInput } from "../../components/inputbox";
import { PrimaryButton } from "../../components/button";

import ForgotPassword from "./forgotpassword";

import images from "../../assets";

import "./styles.css";

const containsNonNumericCharacters = (str) => {
  return /\D/.test(str);
};

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profileData = useSelector((state) => state?.profile?.profile);

  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(40);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [state, setState] = useState({
    newPassword: "",
    isNewPassword: true,
    confirmPassword: "",
    isConfirmPassword: true,
    otp: "",
    error: "",
    otpKey: Date.now(),
  });

  useEffect(() => {
    setResendDisabled(true);
    setTimer(40);
  }, []);

  useEffect(() => {
    if (resendDisabled && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else if (timer === 0) {
      setResendDisabled(false);
    }
  }, [timer, resendDisabled]);

  const handleResendClick = () => {
    handleResendOTP();
    setTimer(40);
    setResendDisabled(true);
  };

  const handleResendOTP = () => {
    const payload = { username: profileData?.email };
    dispatch(AuthAction.resendOtp(payload));
  };

  const defaultStates = () => {
    setState({
      newPassword: "",
      isNewPassword: true,
      confirmPassword: "",
      isConfirmPassword: true,
      otp: "",
      error: "",
      otpKey: Date.now(),
    });
  };

  const handleSubmit = () => {
    if (!state?.newPassword || !state?.confirmPassword) {
      setState({
        ...state,
        error: "Please fill all the fields",
      });
    } else if (
      state?.newPassword?.length < 6 ||
      state?.confirmPassword?.length < 6
    ) {
      setState({
        ...state,
        error: "Password should be atleast 6 characters long",
      });
    } else if (state?.newPassword !== state?.confirmPassword) {
      setState({
        ...state,
        error: "Passwords do not match",
      });
    } else {
      setState({
        ...state,
        error: "",
      });
      const payload = {
        username: profileData?.email,
      };
      dispatch(
        AuthAction.forgotPassword(payload, (res) => {
          if (res === 200) {
            setIsOtpModalOpen(true);
          } else {
            defaultStates();
          }
        })
      );
    }
  };
  const handleOtpSubmit = () => {
    if (containsNonNumericCharacters(state.otp)) {
      message.error("OTP must be a number");
      return;
    }
    const payload = {
      code: parseInt(state?.otp),
      password: state?.newPassword,
      username: profileData?.email,
    };
    dispatch(
      AuthAction.confirmPassword(payload, () => {
        setIsOtpModalOpen(false);

        defaultStates();
      })
    );
  };
  return (
    <div className="change-password-container">
      <div className="change-password-top-part-container">
        <h1 className="change-password-title">Password</h1>
        <Spacer height="4px" />
        <p className="change-password-subtitle">
          Set a unique password to protect your account.
        </p>
      </div>
      <div className="content-container">
        <GreyButton
          text="Back"
          icon={images.whiteButtonBack}
          iconalign="left"
          onClick={() => navigate("/settings")}
        />
        <div className="change-password-content">
          <img src={images.changePassword} alt="" />

          <Spacer height="36px" />
          <div className="relative w-full">
            <div>
              <TextInput
                className="password-input"
                type={state?.isNewPassword ? "password" : "text"}
                placeholder="Enter new password"
                onChange={(e) =>
                  setState({ ...state, newPassword: e.target.value })
                }
                value={state?.newPassword}
              />
              <img
                src={state?.isNewPassword ? images.eyeOfIcon : images.eyeIcon}
                className="h-5 absolute top-3 right-4"
                onClick={() =>
                  setState({ ...state, isNewPassword: !state.isNewPassword })
                }
                alt="see"
              />
            </div>
          </div>
          <Spacer height="36px" />
          <div className="relative w-full">
            <div>
              <TextInput
                className="password-input"
                type={state?.isConfirmPassword ? "password" : "text"}
                placeholder="Confirm new password"
                onChange={(e) =>
                  setState({ ...state, confirmPassword: e.target.value })
                }
                value={state?.confirmPassword}
              />
              <img
                src={
                  state?.isConfirmPassword ? images.eyeOfIcon : images.eyeIcon
                }
                className="h-5 absolute top-3 right-4"
                onClick={() =>
                  setState({
                    ...state,
                    isConfirmPassword: !state.isConfirmPassword,
                  })
                }
                alt="see"
              />
            </div>
          </div>
          <Spacer height="5px" />
          {state?.error && (
            <div className="text-center">
              <p className="text-danger font-semibold text-[14px] m-0">
                {state?.error}
              </p>
            </div>
          )}
          <Spacer height="36px" />
          <PrimaryButton text={"Update Password"} onClick={handleSubmit} />
          <Spacer height="16px" />

          <p
            className="forgot-password-text"
            onClick={() => setIsModalOpen(true)}
          >
            Forgot Your Password?
          </p>
        </div>
      </div>

      <Modal
        centered={true}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={false}
        closable={false}
        className="forgot-password-modal"
      >
        <img
          src={images?.closeIcon}
          className="modal-close-icon"
          alt=""
          onClick={() => setIsModalOpen(false)}
        />
        <ForgotPassword setIsModalOpen={setIsModalOpen} />
      </Modal>

      <Modal
        centered={true}
        open={isOtpModalOpen}
        onCancel={() => setIsOtpModalOpen(false)}
        footer={false}
        closable={false}
        className="forgot-password-modal"
      >
        <div className="flex justify-center flex-col items-center">
          <img src={images?.otpIcon} alt="" />
          <Spacer height="32px" />
          <h2 className="forgot-password-title">
            Please enter the verification code sent to your Email.
          </h2>
          <Spacer height="24px" />

          <CodeInput
            onChange={(val) => setState({ ...state, otp: val, error: "" })}
            value={state?.otp}
          />

          {state?.error && (
            <div className="text-center">
              <p className="text-danger font-semibold text-[14px] m-0">
                {state?.error}
              </p>
            </div>
          )}
          <Spacer height="32px" />
          <PrimaryButton text={"Verify OTP"} onClick={handleOtpSubmit} />
          <Spacer height="16px" />
          <p className="otp-form-bottom-text">
            Haven't received an OTP?{" "}
            <span
              className={`font-bold text-red-600 cursor-pointer ${
                resendDisabled && "pointer-events-none opacity-60"
              }`}
              onClick={!resendDisabled ? handleResendClick : null}
            >
              Resend {resendDisabled && `(${timer}s)`}
            </span>
          </p>
          <p className="otp-form-bottom-text">
            Make sure you have checked your spam / junk box.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default ChangePassword;
